import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from 'src/common/store/selectors';
import { RootState } from 'src/store';
import { selectClientId } from '../../../common/store/selectors';
import {
  fetchApprovedProducts,
  selectApprovedProducts,
  selectAssetClasses,
  selectCurrentInvestmentVersionId,
  selectInvestmentService,
  selectSecurities,
} from './../../store/common';
import { Targets } from './components/targets';
import {
  ConfigurationsActionTypes,
  fetchConfigurations,
  fetchStrategicAllocations,
  saveConfigurations,
  saveStrategicAllocations,
  selectCashAccountProduct,
  selectConfigurations,
  selectStrategicAllocations,
  StrategicAllocationActionTypes,
  targetsSlice,
} from './store';

const mapStateToProps = (state: RootState) => ({
  clientId: selectClientId(state),
  configurations: selectConfigurations(state),
  currentInvestmentVersionId: selectCurrentInvestmentVersionId(state),
  investmentService: selectInvestmentService(state),
  loadingConfigurationsProgress: progressSelectorFactory([ConfigurationsActionTypes.FetchConfigurations])(state),
  savingConfigurationsProgress: progressSelectorFactory([ConfigurationsActionTypes.SaveConfigurations])(state),

  strategicAllocations: selectStrategicAllocations(state),
  loadingStrategicAllocationsProgress: progressSelectorFactory([StrategicAllocationActionTypes.FetchStrategicAllocations])(state),
  savingStrategicAllocationsProgress: progressSelectorFactory([StrategicAllocationActionTypes.UpdateStrategicAllocation])(state),

  securities: selectSecurities(state),
  assetClasses: selectAssetClasses(state),
  approvedProducts: selectApprovedProducts(state),
  cashAccountProduct: selectCashAccountProduct(state),
});

const mapDispatchToProps = {
  ...targetsSlice.actions,

  fetchConfigurations,
  saveConfigurations,

  fetchStrategicAllocations,
  saveStrategicAllocations,

  fetchApprovedProducts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const TargetsContainer = connector(Targets);
